module.exports = __webpack_public_path__ + "static/chili-piper-fe25c8a900e40363b6d5ad554cecbb62.jpeg";